import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { PRIORITY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformJiraPriorityToLegacyPriority = (priority) => {
	if (priority == null) return null;

	return {
		id: priority.priorityId,
		iconUrl: String(priority.iconUrl || ''), // iconUrl is AGG$URL in the schema
		name: priority.name || '',
		sequence: priority.sequence || undefined,
	};
};

export const transformAggPriorityToLegacyField: FieldTransformer<typeof PRIORITY_TYPE> = (node) => {
	if (node.type !== PRIORITY_TYPE) return undefined;

	// With cleanup of dfo_remove_priority_field_from_main_query, priorities will not be in node, and allowedValues will be an empty array
	const allowedValues = transformAggConnection(
		'priorities' in node ? node.priorities : null,
		transformJiraPriorityToLegacyPriority,
	);

	return {
		...transformAggNodeToLegacyField(node),
		allowedValues,
		value: transformJiraPriorityToLegacyPriority(node.priority),
		schema: {
			type: PRIORITY_TYPE,
			custom: null,
			system: PRIORITY_TYPE,
			configuration: null,
			items: null,
			renderer: PLAIN_TEXT,
		},
	};
};
